import type { APIConfig } from '@ps/web-core-api';
import { WMTDisconnectReason, connect } from '@ps/web-core-api';
import { canUseDOM } from '@ps/web-core-utils';

import type { Store } from '../types';

const WMT_RECONNECT = 1000;

export const WMTConnection = (
  { getState, select, dispatch }: Store,
  overrides?: Partial<APIConfig>
) => {
  const url = new URL(select.location.getOrigin(getState()));
  url.pathname = '/api/v0/websocket';

  return connect({
    requestDestination: '/service/',
    requestTimeout: select.config.get(getState()).requestTimeout ?? 20000,
    responseChannel: '/user/queue/messages',
    url: canUseDOM ? url.pathname : url.toString(),
    sockJSOptions: { transports: ['websocket'] },
    getHeaders: () => {
      const authorization = select.session.getWMTAuthorization(getState());
      if (authorization) return { authorization };
    },
    getReconnect: (currentDelay: number, reason: WMTDisconnectReason) => {
      if (reason === WMTDisconnectReason.InvalidToken) {
        dispatch.session.clear();
      }
      if (!currentDelay) {
        return reason === WMTDisconnectReason.VelocityControl ? WMT_RECONNECT : 1;
      }
      return currentDelay === 1 ? WMT_RECONNECT : currentDelay * 2;
    },
    ...overrides
  });
};
